@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (box3Leningen.length > 0) {
      <div formArrayName="box3Leningen">
        @for (item of box3Leningen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Leningnummer' : ''"
                                              class="custom-input-150"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Schuld 1-1-' + jaar : ''"
                                                [minValue]="0"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Aanwending lening' : ''"
                                                [options]="soortAanwending"
                                                class="custom-input-150"
                                                formControlName="aanwending"
              >
              </snelstart-ui-select-form-control>
              @if (item.get('aanwending')?.value !== null && item.get('aanwending')?.value !== LeningAanwending.OVERIG) {
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Kies woning' : ''"
                                                  [options]="optionsOnroerendeZaken"
                                                  class="col-auto custom-input-150"
                                                  formControlName="wozNummerWaarLeningBijHoort"
                                                  placeholder="n.v.t"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Land van lening' : ''"
                                                  [options]="optionsLandcodes"
                                                  class="col-auto custom-input-150"
                                                  formControlName="landCode"
                                                  placeholder="n.v.t"
                >
                </snelstart-ui-select-form-control>
              }
              <snelstart-ui-button (click)="showDialog(i)"
                                   [disabled]="!heeftOWR"
                                   [class]="i === 0 ? 'pt-3 custom-input-100' : 'custom-input-100'"
                                   [icon]="'plus'"
                                   type="secondary">
                OWR
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" type="link">
    Schuld toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                  [title]="getOWRDialogTitel(index)"
                                  id="owrLeningen"
                                  size="lg">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if (box3Leningen.length > 0) {
          <div formArrayName="box3Leningen">
            @for (item of box3Leningen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="'Schuld 31-12-' + jaar"
                                                    [minValue]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="hoofdsom3112"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="'Betaalde rente in ' + jaar"
                                                    [minValue]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="rente"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="'Bijzondere waardeverandering'"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="bijzondereWaardevermindering"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="'Werkelijk rendement'"
                                                    [disabledControl]="true"
                                                    [calculate]="getBerekendeWerkelijkRendement(i)"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="berekendRendement"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                }
              </div>
            }
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}


